/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Not_Null_ViolationInputs */

const en_error_not_null_violation = /** @type {(inputs: Error_Not_Null_ViolationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A required value is missing.`)
};

/**
* | output |
* | --- |
* | "A required value is missing." |
*
* @param {Error_Not_Null_ViolationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_not_null_violation = /** @type {((inputs?: Error_Not_Null_ViolationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Not_Null_ViolationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_not_null_violation(inputs)
});